import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};


// ✅ Get Measurement Units List (Admin)
export const getMeasurementUnitsList = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/get-measurement-units-list", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
        ...params,
      },
    });

    return res.data; 
    // { data: [...units], message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
export const addMeasurementUnits = async (units) => {
  const formData = new FormData();

  units.forEach((unit, index) => {
    formData.append(`units[${index}][name]`, unit.name ?? "");
    formData.append(`units[${index}][abbreviation]`, unit.abbreviation ?? "");
    formData.append(`units[${index}][name_en]`, unit.name_en ?? "");
  });

  const res = await api.post("/admin/add-measurement-unit", formData, {
    headers: {
      ...getAuthHeaders(),
      // سيب axios يحدد Content-Type + boundary
    },
    // params مش لازم هنا لو موجودة في api instance
    // params: { api_password: "AI_Pos_passCode2026" },
  });

  return res.data;
};
// ✅ Update Measurement Unit (Admin)
export const updateMeasurementUnit = async ({
  id,
  name,
  name_en,
  abbreviation,
}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  const formData = new FormData();
  formData.append("name", String(name || ""));
  formData.append("name_en", String(name_en || ""));
  formData.append("abbreviation", String(abbreviation || ""));

  try {
    const res = await api.post(
      `/admin/update-measurement-unit/${id}`,
      formData,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data; // { data: {...}, message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

// ✅ Get Materials List (Admin)
export const getMaterialsList = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/get-materials-list", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
        ...params, // لو حابب تضيف فلترة مستقبلاً
      },
    });

    return res.data; 
    // { data: [...materials], message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Add Materials (Admin) - JSON body
export const addMaterials = async (materials = []) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  try {
    const res = await api.post(
      "/admin/add-material",
      { materials },
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data; // { data: [...], message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Update Material (Admin) - JSON body
export const updateMaterial = async ({
  id,
  name,
  name_en,
  measurement_unit_id,
  priority = "A",
  cost_price_per_unit,
  status,
  stock_quantity,
  max_usage_per_product,
  min_stock_threshold,
  keywords = [],
  rules = [],
}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const body = {
    name: String(name || ""),
    name_en: String(name_en || ""),
    measurement_unit_id: Number(measurement_unit_id),
    priority: String(priority || "A").toUpperCase(),
    cost_price_per_unit: Number(cost_price_per_unit),
    status: Boolean(status),
    stock_quantity:
      stock_quantity === null || stock_quantity === undefined || stock_quantity === ""
        ? null
        : Number(stock_quantity),
    max_usage_per_product: Number(max_usage_per_product),
    min_stock_threshold:
      min_stock_threshold === null || min_stock_threshold === undefined || min_stock_threshold === ""
        ? null
        : Number(min_stock_threshold),
    keywords: Array.isArray(keywords) ? keywords : [],
    rules: Array.isArray(rules) ? rules : [],
  };

  try {
    const res = await api.post(`/admin/update-material/${id}`, body, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data; // { data: {...}, message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
